export default "__VITE_ASSET__CTsPLD8K__"